import { CommonProp, generate } from '@acin/ui-core';
import React from 'react';
import { useParams } from 'react-router-dom';
import { RegulationDetail } from '../../../components/RegulationDetail';
import { RegulationDetailProvider } from '../../../components/RegulationDetailProvider';
import { RegulationProvider } from '../../../components/RegulationProvider';
import * as SC from './Regulation.styled';

export interface RegulationProps extends CommonProp {
  className?: string;
}

export const Regulation: React.FC<RegulationProps> = (props) => {
  const { className } = props;
  const { regulationId } = useParams<{ regulationId: string; tabId: string }>();

  return (
    <RegulationDetailProvider regulationId={regulationId}>
      <RegulationProvider>
        <SC.Regulation data-testid={generate(['reg-mapping-regulation'], props)} className={className}>
          <RegulationDetail />
        </SC.Regulation>
      </RegulationProvider>
    </RegulationDetailProvider>
  );
};
